import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CurrencyFormatPipe } from '../common/pipe/currency-format.pipe';
import {MenuModule} from 'primeng/menu';
import { ButtonAgGridComponent } from '../common/ag-component/button-renderermutibuttons.component';
import {ButtonModule} from 'primeng/button';
import { AvatarFullComponent } from '../common/ag-component/avatarFull.component';
import {RatingModule} from 'primeng/rating';

@NgModule({
    exports: [
        CurrencyFormatPipe,
        ButtonAgGridComponent,
        AvatarFullComponent,
    ],
    imports: [
        RouterModule,
        CommonModule,
        MenuModule,
        ButtonModule,
        RatingModule
    ],
    declarations: [
        CurrencyFormatPipe,
        ButtonAgGridComponent,
        AvatarFullComponent,
    ],
    entryComponents: [

    ]
})
export class SharedCommonModule { }
